import { post } from '@/utils/request'

export function trackPageView(pagePath) {
  return post('/blog/analytics/track', {
    eventType: 'page_view',
    pagePath
  }).catch(() => {})
}

export function trackEvent(eventType, pagePath) {
  return post('/blog/analytics/track', { eventType, pagePath }).catch(() => {})
}
